import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const PROPERTY_FAQ_ANSWER_AUTH_SOURCE = "qa_answer";
export const PROPERTY_FAQ_ASK_DEVELOPER_SOURCE = "qa_ask_developer";

export type PropertyFaqItemAction = "expand" | "collapse";
export type PropertyFaqQuestionType = "default" | "custom";

export interface IPropertyFaqAnalyticsProduct {
    answerContent: string | null;
    index: number;
    questionHeading: string;
    questionType: PropertyFaqQuestionType;
}

interface IPropertyFaqAnalyticsContext {
    itemId: number;
    propertyId: number;
}

export interface IPropertyFaqQuestionAnalyticsContext extends IPropertyFaqAnalyticsContext {
    index: number;
    questionHeading: string;
    questionType: PropertyFaqQuestionType;
}

type IPropertyFaqCustomQuestionAnalyticsContext = Omit<IPropertyFaqQuestionAnalyticsContext, "questionType"> & {
    questionType: "custom";
};

type IPropertyFaqDefaultQuestionAnalyticsContext = Omit<IPropertyFaqQuestionAnalyticsContext, "questionType"> & {
    questionType: "default";
};

interface IPropertyFaqSectionViewParams extends IPropertyFaqAnalyticsContext {
    products: IPropertyFaqAnalyticsProduct[];
}

interface IPropertyFaqExpandQuestionParams extends IPropertyFaqQuestionAnalyticsContext {
    answerContent: string | null;
}

const listView = () => {
    hitGoogleTagManager({
        event: "qa_faq_list",
        event_action: "view"
    });
};

const itemToggle = (action: PropertyFaqItemAction, question: string, position: number) => {
    hitGoogleTagManager({
        event: "qa_faq_item",
        event_action: action,
        event_label: question,
        event_category: position
    });
};

const answerPaywallView = () => {
    hitGoogleTagManager({
        event: "qa_answer_paywall",
        event_action: "view"
    });
};

const answerCtaClick = (clickText: string) => {
    hitGoogleTagManager({
        event: "qa_answer_cta",
        event_action: "click",
        event_label: clickText
    });
};

const askDeveloperClick = (clickText: string) => {
    hitGoogleTagManager({
        event: PROPERTY_FAQ_ASK_DEVELOPER_SOURCE,
        event_action: "click",
        event_label: clickText
    });
};

const sectionView = (params: IPropertyFaqSectionViewParams) => {
    trackAmplitudeEvent("view_section", {
        section_name: "faq",
        location: "property_page",
        item_id: params.itemId,
        property_id: params.propertyId,
        products: params.products.map((product) => ({
            question_heading: product.questionHeading,
            index: product.index,
            question_type: product.questionType,
            answer_content: product.answerContent
        }))
    });
};

const expandQuestion = (params: IPropertyFaqExpandQuestionParams) => {
    trackAmplitudeEvent("expand_section", {
        section_name: "faq",
        location: "property_page",
        item_id: params.itemId,
        property_id: params.propertyId,
        question_heading: params.questionHeading,
        answer_content: params.answerContent,
        index: params.index,
        question_type: params.questionType
    });
};

const trackQuestionButtonClick = (buttonName: string, value: string, params: IPropertyFaqQuestionAnalyticsContext) => {
    trackAmplitudeEvent("button_click", {
        button_name: buttonName,
        value,
        button_link: null,
        button_category: "property_page",
        item_id: params.itemId,
        property_id: params.propertyId,
        question_heading: params.questionHeading,
        index: params.index,
        question_type: params.questionType
    });
};

const moreInfoClick = (params: IPropertyFaqCustomQuestionAnalyticsContext) => {
    trackQuestionButtonClick("rp_faq_more_info", "more_info", params);
};

const confirmAddressClick = (params: IPropertyFaqDefaultQuestionAnalyticsContext) => {
    trackQuestionButtonClick("rp_faq_confirm_address", "confirm", params);
};

const seeOnMapClick = (params: IPropertyFaqDefaultQuestionAnalyticsContext) => {
    trackQuestionButtonClick("rp_faq_see_on_map", "see_on_map", params);
};

export const propertyFaqAnalytics = {
    gtm: {
        listView,
        itemToggle,
        answerPaywallView,
        answerCtaClick,
        askDeveloperClick
    },
    amplitude: {
        sectionView,
        expandQuestion,
        moreInfoClick,
        confirmAddressClick,
        seeOnMapClick
    }
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const PROPERTY_FAQ_ANSWER_AUTH_SOURCE = "qa_answer";
export const PROPERTY_FAQ_ASK_DEVELOPER_SOURCE = "qa_ask_developer";

export type PropertyFaqItemAction = "expand" | "collapse";
export type PropertyFaqQuestionType = "default" | "custom";

export interface IPropertyFaqAnalyticsProduct {
    answerContent: string | null;
    index: number;
    questionHeading: string;
    questionType: PropertyFaqQuestionType;
}

interface IPropertyFaqAnalyticsContext {
    itemId: number;
    propertyId: number;
}

export interface IPropertyFaqQuestionAnalyticsContext extends IPropertyFaqAnalyticsContext {
    index: number;
    questionHeading: string;
    questionType: PropertyFaqQuestionType;
}

type IPropertyFaqCustomQuestionAnalyticsContext = Omit<IPropertyFaqQuestionAnalyticsContext, "questionType"> & {
    questionType: "custom";
};

type IPropertyFaqDefaultQuestionAnalyticsContext = Omit<IPropertyFaqQuestionAnalyticsContext, "questionType"> & {
    questionType: "default";
};

interface IPropertyFaqSectionViewParams extends IPropertyFaqAnalyticsContext {
    products: IPropertyFaqAnalyticsProduct[];
}

interface IPropertyFaqExpandQuestionParams extends IPropertyFaqQuestionAnalyticsContext {
    answerContent: string | null;
}

const listView = () => {
    hitGoogleTagManager({
        event: "qa_faq_list",
        event_action: "view"
    });
};

const itemToggle = (action: PropertyFaqItemAction, question: string, position: number) => {
    hitGoogleTagManager({
        event: "qa_faq_item",
        event_action: action,
        event_label: question,
        event_category: position
    });
};

const answerPaywallView = () => {
    hitGoogleTagManager({
        event: "qa_answer_paywall",
        event_action: "view"
    });
};

const answerCtaClick = (clickText: string) => {
    hitGoogleTagManager({
        event: "qa_answer_cta",
        event_action: "click",
        event_label: clickText
    });
};

const askDeveloperClick = (clickText: string) => {
    hitGoogleTagManager({
        event: PROPERTY_FAQ_ASK_DEVELOPER_SOURCE,
        event_action: "click",
        event_label: clickText
    });
};

const sectionView = (params: IPropertyFaqSectionViewParams) => {
    trackAmplitudeEvent("view_section", {
        section_name: "faq",
        location: "property_page",
        item_id: params.itemId,
        property_id: params.propertyId,
        products: params.products.map((product) => ({
            question_heading: product.questionHeading,
            index: product.index,
            question_type: product.questionType,
            answer_content: product.answerContent
        }))
    });
};

const expandQuestion = (params: IPropertyFaqExpandQuestionParams) => {
    trackAmplitudeEvent("expand_section", {
        section_name: "faq",
        location: "property_page",
        item_id: params.itemId,
        property_id: params.propertyId,
        question_heading: params.questionHeading,
        answer_content: params.answerContent,
        index: params.index,
        question_type: params.questionType
    });
};

const trackQuestionButtonClick = (buttonName: string, value: string, params: IPropertyFaqQuestionAnalyticsContext) => {
    trackAmplitudeEvent("button_click", {
        button_name: buttonName,
        value,
        button_link: null,
        button_category: "property_page",
        item_id: params.itemId,
        property_id: params.propertyId,
        question_heading: params.questionHeading,
        index: params.index,
        question_type: params.questionType
    });
};

const moreInfoClick = (params: IPropertyFaqCustomQuestionAnalyticsContext) => {
    trackQuestionButtonClick("rp_faq_more_info", "more_info", params);
};

const confirmAddressClick = (params: IPropertyFaqDefaultQuestionAnalyticsContext) => {
    trackQuestionButtonClick("rp_faq_confirm_address", "confirm", params);
};

const seeOnMapClick = (params: IPropertyFaqDefaultQuestionAnalyticsContext) => {
    trackQuestionButtonClick("rp_faq_see_on_map", "see_on_map", params);
};

export const propertyFaqAnalytics = {
    gtm: {
        listView,
        itemToggle,
        answerPaywallView,
        answerCtaClick,
        askDeveloperClick
    },
    amplitude: {
        sectionView,
        expandQuestion,
        moreInfoClick,
        confirmAddressClick,
        seeOnMapClick
    }
};
